import { OktaAuth } from '@okta/okta-auth-js'

class AuthService {
  constructor() {
    this.oktaAuth = new OktaAuth({
      issuer: import.meta.env.VITE_OKTA_ISSUER,
      clientId: import.meta.env.VITE_OKTA_CLIENTID,
      redirectUri: import.meta.env.VITE_OKTA_REDIRECT_URI || `${window.location.origin}/auth/callback`,
      postLogoutRedirectUri: import.meta.env.VITE_OKTA_LOGOUT_REDIRECT_URI || `${window.location.origin}/auth/logout`,
      scopes: ['openid', 'profile', 'email'],
      pkce: true,
      responseType: 'code'
    });
  }

  async signInWithRedirect(options = {}) {
    try {
      await this.oktaAuth.signInWithRedirect(options);
    } catch (error) {
      console.error('Sign-in redirect error:', error);
      throw error;
    }
  }

  async handleLoginRedirect() {
    try {
      await this.oktaAuth.handleLoginRedirect();
    } catch (error) {
      console.error('Handle login redirect error:', error);
      throw error;
    }
  }

  async isAuthenticated() {
    try {
      return await this.oktaAuth.isAuthenticated();
    } catch (error) {
      console.error('Authentication check error:', error);
      return false;
    }
  }

  async getAccessToken() {
    try {
      const accessToken = this.oktaAuth.getAccessToken();
      return accessToken;
    } catch (error) {
      console.error('Get access token error:', error);
      return null;
    }
  }

  async getIdToken() {
    try {
      const idToken = this.oktaAuth.getIdToken();
      return idToken;
    } catch (error) {
      console.error('Get ID token error:', error);
      return null;
    }
  }

  async getUserInfo() {
    try {
      const user = await this.oktaAuth.getUser();
      return user;
    } catch (error) {
      console.error('Get user info error:', error);
      return null;
    }
  }

  async signOut() {
    try {
      await this.oktaAuth.signOut();
    } catch (error) {
      console.error('Sign out error:', error);
      throw error;
    }
  }

  getOriginalUri() {
    return this.oktaAuth.getOriginalUri();
  }

  setOriginalUri(uri) {
    this.oktaAuth.setOriginalUri(uri);
  }
}

// Create and export a singleton instance
const authService = new AuthService();
export default authService;
